export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
